export const COUNTRY_CODE = '998';